import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from '@material-ui/core';

export default function ConversationList({
    conversations,
    activeSessionId,
    isLoading,
    isLoadingList,
    onSelect,
    onDelete,
    onNew,
}) {
    // Conversation pending deletion confirmation. Null when the dialog is closed;
    // otherwise holds { sessionId, title } so the dialog can name the chat being
    // removed. Deletion is irreversible, so we gate it behind a confirm step
    // instead of firing onDelete straight from the trash button.
    const [pendingDelete, setPendingDelete] = useState(null);

    const requestDelete = (conv) => setPendingDelete({ sessionId: conv.sessionId, title: conv.title });
    const cancelDelete = () => setPendingDelete(null);
    const confirmDelete = () => {
        if (pendingDelete) onDelete(pendingDelete.sessionId);
        setPendingDelete(null);
    };

    return (
        <aside className="conversation-list">
            <button className="btn-new" onClick={onNew} disabled={isLoading}>
                {isLoading ? '...' : '+ Nueva conversación'}
            </button>

            {isLoadingList && (
                <div className="conversation-list__skeleton">
                    {[1, 2, 3, 4, 5].map((i) => (
                        <div key={i} className="skeleton-item" aria-hidden="true">
                            <div className="skeleton-line skeleton-line--title" />
                            <div className="skeleton-line skeleton-line--date" />
                        </div>
                    ))}
                </div>
            )}

            <ul>
                {conversations.map((conv) => (
                    <li
                        key={conv.sessionId}
                        className={`${conv.sessionId === activeSessionId ? 'active' : ''} ${isLoading && conv.sessionId === activeSessionId ? 'loading' : ''}`}
                    >
                        <button
                            className="conv-item"
                            onClick={() => onSelect(conv.sessionId)}
                            disabled={isLoading}
                        >
                            <span className="conv-title">{conv.title}</span>
                            <span className="conv-date">
                                {new Date(conv.updatedAt).toLocaleDateString()}
                            </span>
                        </button>
                        <button
                            className="btn-delete"
                            onClick={(e) => {
                                e.stopPropagation();
                                requestDelete(conv);
                            }}
                            aria-label={`Delete ${conv.title}`}
                            disabled={isLoading}
                        >
                            ×
                        </button>
                    </li>
                ))}
            </ul>

            {!isLoadingList && conversations.length === 0 && (
                <p className="conversation-list__empty">No hay conversaciones aún.</p>
            )}

            {/* Irreversible-delete confirmation. The backend removes the
                conversation permanently, so we require an explicit confirm and
                spell out that it cannot be undone. */}
            <Dialog
                open={pendingDelete !== null}
                onClose={cancelDelete}
                aria-labelledby="delete-conversation-title"
                aria-describedby="delete-conversation-description"
            >
                <DialogTitle id="delete-conversation-title">
                    ¿Eliminar esta conversación?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="delete-conversation-description">
                        Estás por eliminar
                        {pendingDelete && pendingDelete.title ? ` "${pendingDelete.title}"` : ' esta conversación'}.
                        Esta acción es permanente y no hay forma de recuperarla.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancelDelete} color="default">
                        Cancelar
                    </Button>
                    <Button onClick={confirmDelete} color="secondary" variant="contained" autoFocus>
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>
        </aside>
    );
}
